import { SmIcon } from '@smiles/smiles-react-design-system';
import React from 'react';

export interface IErrorMessageProps {
  isActive: boolean;
  message: string;
}

export const ErrorMessage = ({ isActive, message, ...props }: IErrorMessageProps) => {
  return (
    <section className={`car-search-error-message-container${isActive ? ' visible' : ''}`} {...props}>
      <article className="car-search-error-message-wrapper">
        <SmIcon className="car-search-error-message-icon" name="info_outline" type="round" />
        <span className="car-search-error-message-text">{message}</span>
      </article>
    </section>
  );
};
